export const LAST_SYNC_INFO_LOCAL_DOC_ID = "lastSyncInfo";
//# sourceMappingURL=LastSyncInfo.js.map